// extracted by mini-css-extract-plugin
export default {"button":"InProgButton_button__CLtO5"};